import { useEffect } from "react";

import {
  buildPlacementObservedState,
  planWorldPlacement,
} from "../../world-model/placement";

function currentState() {
  return window.__lastWorldObservation?.symbolicState || {
    portal: window.__appState?.currentPortal || "root",
    currentStateKey: window.__appState?.currentMesh || window.__appState?.currentPortal || "root",
    focusedEntityId: window.__appState?.currentMesh || null,
  };
}

export function WorldPlacementLayer() {
  useEffect(() => {
    const commit = async (plan) => {
      const before = currentState();
      const observedState = buildPlacementObservedState({
        plan,
        previousState: before,
      });
      window.__worldPlacementState = {
        revision: observedState.worldRevision,
        ...observedState.placement,
        instances: plan.instances,
      };
      window.dispatchEvent(new CustomEvent("world-placement-committed", {
        detail: { plan, observedState },
      }));


    };

    const handleRequest = (event) => {
      const plan = planWorldPlacement({
        request: event.detail,
        sceneSnapshot: window.__sceneObservationSnapshot,
      });
      if (!plan) {
        console.warn("⚠️ World placement request ignored: no valid plan.");
        return;
      }
      window.__lastWorldPlacementPlan = plan;
      void commit(plan);
    };

    window.addEventListener("world-placement-requested", handleRequest);
    return () => window.removeEventListener("world-placement-requested", handleRequest);
  }, []);

  return null;
}
